module.exports = __webpack_public_path__ + "media/empty-states/signatures-143a76f0.png";